import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';
import { flattenToAppURL } from '@plone/volto/helpers';
import {
  InternalLayoutProvider,
  SubHomeLayout,
} from 'volto-ministerio-publico-federal/components/Layouts';
import { RenderBlocksWithoutTitle } from 'volto-ministerio-publico-federal/components/View/InternalView/RenderBlocksWithoutTitle';
import type { SubHomeViewProps } from 'volto-ministerio-publico-federal/components/View/SubHomeView';

export function temTituloNaBusca(content: SubHomeViewProps['content']) {
  const blocks = (content as { blocks?: Record<string, any> })?.blocks ?? {};
  return Object.values(blocks).some(
    (bloco) =>
      bloco?.['@type'] === 'mpfServicosBusca' &&
      bloco?.tituloPrincipal !== false,
  );
}

const semBarraFinal = (caminho: string) => caminho.replace(/\/+$/, '');

export function destinoSemLogin(
  contentId: string | undefined,
  pathname: string,
  logado: boolean,
): string | null {
  if (logado || !contentId) return null;
  const caminho = semBarraFinal(flattenToAppURL(contentId));
  if (caminho !== semBarraFinal(pathname)) return null;
  const pai = caminho.slice(0, caminho.lastIndexOf('/'));
  return pai || null;
}

const ServicosView = ({ content }: SubHomeViewProps) => {
  const { title, description, relatedItems } = content || {};
  const { pathname, search } = useLocation();
  const logado = useSelector((state: any) => Boolean(state.userSession?.token));
  const destino = destinoSemLogin(content?.['@id'], pathname, logado);

  if (destino) {
    return <Redirect to={`${destino}${search}`} />;
  }

  return (
    <InternalLayoutProvider
      title={title}
      description={description}
      relatedItems={relatedItems}
      larguraTotal
    >
      <SubHomeLayout
        tituloOculto={!temTituloNaBusca(content)}
        className="mpf-servicos-pagina"
      >
        <RenderBlocksWithoutTitle content={content} />
      </SubHomeLayout>
    </InternalLayoutProvider>
  );
};

export default ServicosView;
